import { breakpoints, Button, Inline, Stack, Text, textVariants, vars } from '@etg/wings';
import { ContentWrapper, LoadingDots, variants } from '@eti/components';
import { useProperty, useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import { useMediaQuery } from 'usehooks-ts';
import EtgFaresPrice from './EtgFaresPrice';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const stickyFooterStyles = css`
  align-items: center;
  bottom: 0;
  display: flex;
  margin-top: auto;
  position: sticky;
  width: 100%;
`;
const buttonContainerStyles = isDesktop => css`
  background-color: ${vars.colors.surface.primary};
  border-top: solid ${vars.colors.divider} 1px;
  height: ${isDesktop ? '84px' : '80px'};
  width: 100%;
`;
const contentWrapperStyles = css`
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: space-between;
`;
const inlineStyles = css`
  flex: 1;

  @media (min-width: ${breakpoints._768}) {
    flex: initial;
  }
`;
const EtgFaresStickyFooter = ({
  handlePriceModalOpen,
  includedInTripProductPrice,
  isSelectTripLoading,
  onProceedClick,
  onSkipStepClick,
  numberOfTravelersWithoutInfants,
  selectedBundlePrice,
  totalTripPrice,
  tripPricePerAdult,
  hasPersuasionModal
}) => {
  const {
    t
  } = useTranslation();
  const {
    p
  } = useProperty();
  const footerVersionTwoEnabled = p('ETG.Fares.Footer.Layout.V2');
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints._768})`);
  const priceComponent = /*#__PURE__*/_jsx(EtgFaresPrice, {
    handlePriceModalOpen: handlePriceModalOpen,
    includedInTripProductPrice: includedInTripProductPrice !== null && includedInTripProductPrice !== void 0 ? includedInTripProductPrice : 0,
    numberOfTravelersWithoutInfants: numberOfTravelersWithoutInfants,
    selectedBundlePrice: selectedBundlePrice,
    totalTripPrice: totalTripPrice,
    tripPricePerAdult: tripPricePerAdult
  });
  const persuasionAriaProps = hasPersuasionModal ? {
    'aria-controls': 'etg-fares-persuasion-modal',
    'aria-expanded': 'false',
    'aria-haspopup': 'dialog'
  } : {};
  const abTestFooterControl = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Inline, {
      alignY: "center",
      className: inlineStyles,
      children: /*#__PURE__*/_jsx(Button, {
        ...persuasionAriaProps,
        className: inlineStyles,
        "data-testid": "etgFares-skipStepButton",
        onClick: onSkipStepClick,
        variant: variants.SECONDARY,
        children: t('YourSelectedTrip.Page.SkipStepButton.Label')
      })
    }), /*#__PURE__*/_jsxs(Inline, {
      alignY: "center",
      className: inlineStyles,
      spacing: isDesktop ? 16 : 8,
      children: [selectedBundlePrice > 0 && priceComponent, /*#__PURE__*/_jsx(Button, {
        className: inlineStyles,
        "data-testid": "etgFares-proceedButton",
        onClick: onProceedClick,
        variant: variants.PRIMARY,
        children: isSelectTripLoading ? /*#__PURE__*/_jsx(LoadingDots, {}) : t('YourSelectedTrip.Page.ProceedButton.EtgFares.Label')
      })]
    })]
  });
  const abTestFooterVariation = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Text, {
      id: "totalPriceText",
      variant: textVariants._16_BOLD,
      children: selectedBundlePrice > 0 && t('Product.ETG.Fares.Total.Price')
    }), /*#__PURE__*/_jsxs(Inline, {
      alignY: "center",
      className: inlineStyles,
      spacing: isDesktop ? 16 : 8,
      children: [selectedBundlePrice > 0 && priceComponent, /*#__PURE__*/_jsx(Button, {
        className: inlineStyles,
        "data-testid": "etgFares-proceedButton",
        onClick: onProceedClick,
        variant: variants.PRIMARY,
        children: isSelectTripLoading ? /*#__PURE__*/_jsx(LoadingDots, {}) : t('YourSelectedTrip.Page.ProceedButton.EtgFares.Label')
      }), /*#__PURE__*/_jsx(Button, {
        ...persuasionAriaProps,
        className: inlineStyles,
        "data-testid": "etgFares-skipStepButton",
        onClick: onSkipStepClick,
        variant: variants.SECONDARY,
        children: t('YourSelectedTrip.Page.SkipStepButton.Label')
      })]
    })]
  });
  return /*#__PURE__*/_jsxs(Stack, {
    className: stickyFooterStyles,
    "data-testid": "etg-fares-sticky-footer",
    spacing: 0,
    children: [!isDesktop && selectedBundlePrice > 0 && priceComponent, /*#__PURE__*/_jsx(Inline, {
      className: buttonContainerStyles(isDesktop),
      noWrap: true,
      spacing: 16,
      children: /*#__PURE__*/_jsxs(ContentWrapper, {
        className: contentWrapperStyles,
        children: [isDesktop && (footerVersionTwoEnabled ? abTestFooterVariation : abTestFooterControl), !isDesktop && /*#__PURE__*/_jsxs(Inline, {
          className: inlineStyles,
          noWrap: true,
          children: [/*#__PURE__*/_jsx(Button, {
            className: inlineStyles,
            "data-testid": "etgFares-skipStepButton",
            onClick: onSkipStepClick,
            variant: variants.SECONDARY,
            children: t('YourSelectedTrip.Page.SkipStepButton.Label')
          }), /*#__PURE__*/_jsx(Button, {
            className: inlineStyles,
            "data-testid": "etgFares-proceedButton",
            onClick: onProceedClick,
            variant: variants.PRIMARY,
            children: isSelectTripLoading ? /*#__PURE__*/_jsx(LoadingDots, {}) : t('YourSelectedTrip.Page.ProceedButton.EtgFares.Label')
          })]
        })]
      })
    })]
  });
};
export default EtgFaresStickyFooter;
//# sourceMappingURL=EtgFaresStickyFooter.js.map